import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';
import { useLocalization } from '../../hooks/useLocalization';
import { FETCH_FORM_TEMPLATE_NAME } from './formTemplateBreadcrumb.query';

export const FormTemplateBreadcrumb = () => {
  const { translateBackendString } = useLocalization();
  const { id } = useParams();
  const { data } = useQuery(FETCH_FORM_TEMPLATE_NAME, {
    variables: { input: { formTemplateId: id } },
    skip: !id,
  });

  return translateBackendString(data?.fetchFormTemplate?.translatedDisplayName);
};
